import { connect } from 'react-redux'
import AddGroup from './add-group'
import { createGroup } from '../../../../../stores/groups/groups.actions'
import { isOpen } from './add-group.selectors'
import { closeAddGroupDialog } from './add-group.actions'
import { getSchoolId } from '../../../../../stores/me/me.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getGroupCreatingStatus } from '../../../../../stores/groups/groups.selectors'

const mapStateToProps = (state, { me }) => ({
  pending: getGroupCreatingStatus(state).pending,
  schoolId: getSchoolId(me),
  opened: isOpen(state)
})

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  requestClose: () => dispatch(closeAddGroupDialog()),
  onSubmit: ({ groupName }) => {
    dispatch(
      createGroup(stateProps.schoolId, {
        title: groupName,
        visibility: 'public'
      })
    ).catch(errorHandler)
  }
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(AddGroup)
)
